import { Typography, styled, Box } from "@mui/material";
const StyledBox = styled(Box)({
  display: "flex",
  width: "full",
  borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
  background: "var(--Tokens-Background-Layer-02, #EFF5FC)",
  padding: "8px 16px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
});

const StyledTypography = styled(Typography)({
  color: "var(--Tokens-Text-Secondary, #616161)",
  fontFamily: "var(--Typography-Font-Family-Body, Inter)",
  fontSize: "var(--Font-Size-Small, 14px)",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "var(--Line-Height-Small, 20px)", // 142.857%
});

const StyledTypography2 = styled(Typography)({
  color: "var(--Tokens-Text-Secondary, #616161)",
  fontFamily: "var(--Typography-Font-Family-Body, Inter)",
  fontSize: "var(--Font-Size-Small, 12px)",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "var(--Line-Height-Small, 18px)", // 142.857%
});

export { StyledBox, StyledTypography, StyledTypography2 };
